import React, {useEffect, useContext} from 'react';
import { systemCode, xs_instantSessionToken, xs_languageCode, xs_sessionToken } from '..';
import { UserContext } from '../data/betslip/UserConf';
import { getConfiguration } from '../data/utils/configuration';
import { appConfig } from '../appConfig';
import { labels } from '../data/labels';

function RouletteHandler(props) {
	const conf = getConfiguration();
	const userContext = useContext(UserContext);
	const user = userContext.getUser();
	const $ = window.$;
	let rouletteConfiguration = null;
	if(conf.bfs && conf.bfs.fms.length > 0){
		for(let kf in conf.bfs.fms){
			if(conf.bfs.fms[kf].enbm && conf.bfs.fms[kf].typ?.includes('ROULETTE')){
				rouletteConfiguration = conf.bfs.fms[kf];
				break;
			}
		}
	}

   
	
	let rouletteUrl = rouletteConfiguration? rouletteConfiguration.lurl : "";
	const mobilePosition = rouletteConfiguration? rouletteConfiguration.rmp : "";
	// showing the button over the TOP one
	if(mobilePosition === 'OVER_TOP_BUTTON'){
		const $roulette = $('#roulette-button-on-body');
		if( $roulette.length > 0){
			const attrBool = $roulette.attr("showed");
			const showed = attrBool && attrBool === 'true';
			if(!showed){
				$roulette.attr("showed", true);
				const label = labels['roulette.title']? labels['roulette.title'] : 'Live Roulette';
				$('#roulette-button-on-body-label').html(label);
				$roulette.attr('style', 'display:flex;');
			}
		}
	}
	
	if(rouletteUrl.length > 0){
		let token = xs_sessionToken;
		if(rouletteUrl.indexOf('instantGame') >= 0 && xs_instantSessionToken){
			token = xs_instantSessionToken;
		}
		rouletteUrl = rouletteUrl.replace(/{{LANGUAGE}}/g, xs_languageCode);
		rouletteUrl = rouletteUrl.replace(/{{TOKEN}}/g, token);
		rouletteUrl = rouletteUrl.replace(/{{SYSTEM_CODE}}/g, systemCode);
	}

	function openRoulette(){
    	if(user.logged){
            if(appConfig && (appConfig.IS_APP_IOS || appConfig.IS_APP_ANDROID)){
                window.location.href = rouletteUrl;
            }
			else{
                window.open(rouletteUrl);
            }
    	}
    	else{
    		window.$('#cg-contoButton').click();
    	}
    }

	useEffect(() => {
		// expose a function for the window
		window.openRoulette = openRoulette;
	});


	return null;
}

export default RouletteHandler;